module.exports = __webpack_public_path__ + "static/media/11.21945e0d.jpeg";